<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="VALUTA.SIFRA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'number'"
              name="txtSifra"
              formControlName="Sifra"
              #focusElement
              [MaxLength]="3"
              [ngClass]="{'is-invalid' : submitted && fc.Sifra.invalid}"
              [Label]="'VALUTA.SIFRANUMERIC.SINGULAR'"
              >
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
                  <span *ngFor="let validation of errorMessages.Sifra">
                    <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <!-- {{Sifra2}} -->
            <yt-input
              [Type]="'text'"
              name="txtSifra"
              formControlName="ISOAlpha3Code"
              #focusElement
              [MaxLength]="3"
              [ngClass]="{'is-invalid' : submitted && fc.ISOAlpha3Code.invalid}"
              [Label]="'VALUTA.ISOALPHA3CODE.SINGULAR'"
              [Uppercase]="true">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.ISOAlpha3Code.invalid">
                  <span *ngFor="let validation of errorMessages.ISOAlpha3Code">
                    <span class="error-message" *ngIf="fc.ISOAlpha3Code.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="VALUTA.NAZIV.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNaziv"
              formControlName="Naziv"
              [MaxLength]="50"
              [ngClass]="{'is-invalid' : submitted && fc.Naziv.invalid}"
              [Label]="'VALUTA.NAZIV.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
